// api
import type {
  CreateGatewayDto,
  GatewaysPostBynewGatewayApiArg,
} from '@/api/generated/recalc/endpoints/v1/gateways';

// shared components
import { EMPTY_ADDRESS_VALUE } from '@/components/ui/form';

// relative
import type { CreateGatewayFormValues } from './createGatewayForm.schema';

export function toCreateGatewayFormValues(): CreateGatewayFormValues {
  return {
    name: '',
    rfuId: '',
    description: '',
    address: EMPTY_ADDRESS_VALUE,
  };
}

export function toPostGatewayPayload(
  values: CreateGatewayFormValues,
  accountId: number,
): GatewaysPostBynewGatewayApiArg {
  const createGatewayDto: CreateGatewayDto = {
    Name: values.name.trim(),
    RfuId: Number(values.rfuId),
    Description: values.description,
    Account: {
      AccountId: accountId,
    },
    Latitude: values.address.latitude ?? undefined,
    Longitude: values.address.longitude ?? undefined,
  };

  return { createGatewayDto };
}
